/**
 * @author
 * David Rivera (jherax)
 * https://github.com/jherax
 */

import isDOM from './isDOM';
import readyDOM from './readyDOM';
import fieldType from './fieldType';
import getFieldValue from './getFieldValue';
import isDateSupported from './isDateSupported';
import addStyleToHead from './addStyleToHead';
import waitForElement from './waitForElement';
import waitForCookie from './waitForCookie';
import waitFor from './waitFor';
import sendGA from './sendGA';
import deprecated from '../../utils/warnings/deprecated';

export default {
  isDOM,
  readyDOM,
  fieldType,
  getFieldValue,
  isDateSupported,
  addStyleToHead,
  waitFor,
  wait: deprecated('hc.wait', 'hc.waitFor', waitForElement),
  waitForCookie: deprecated('hc.waitForCookie', 'hc.waitFor', waitForCookie),
  sendGA,
};
